import React, { Component } from 'react'
import MenuSider from '../../../../components/MenuSider'
import { Select, Collapse, Spin, Button, Table } from 'antd';
import { Odata_Url, Constants, Odata_2_Url } from '../../../../Constants/Constants'
import './SOTarget.css'
import { Col, Row } from 'react-bootstrap';
import IntlMessages from '../../../../util/IntlMessages';

const Panel = Collapse.Panel;
const Option = Select.Option;

function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const month_list = [{ "monthName": <IntlMessages id='January' />, "order": 1 },
{ "monthName": <IntlMessages id='February' />, "order": 2 },
{ "monthName": <IntlMessages id='March' />, "order": 3 },
{ "monthName": <IntlMessages id='April' />, "order": 4 },
{ "monthName": <IntlMessages id='May' />, "order": 5 },
{ "monthName": <IntlMessages id='June' />, "order": 6 },
{ "monthName": <IntlMessages id='July' />, "order": 7 },
{ "monthName": <IntlMessages id='August' />, "order": 8 },
{ "monthName": <IntlMessages id='September' />, "order": 9 },
{ "monthName": <IntlMessages id='October' />, "order": 10 },
{ "monthName": <IntlMessages id='November' />, "order": 11 },
{ "monthName": <IntlMessages id='December' />, "order": 12 }]

export default class SOTarget extends Component {
    constructor(props) {
        super(props)
        this.loadData = this.loadData.bind(this);
        this.handleMonthChange = this.handleMonthChange.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this);

        var _year_now = new Date().getFullYear()
        var _month_now = new Date().getMonth()

        this.state = {
            data: [],
            year_now: _year_now,
            month_now: (_month_now + 1),
            select_year: new Date().getFullYear(),
            select_month: (_month_now + 1),
            onLoading: false
        }

    }

    componentDidUpdate(prevProps, prevState) {
        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        if (isEng !== prevState.isEng)
            this.setState({ isEng: isEng })
    }

    componentWillMount() {
        let state = JSON.parse(window.localStorage.getItem('state'))
        let isEng = state.setting.locale.locale == 'en'
        this.setState({ isEng: isEng })
        this.loadData();
    }

    handleYearChange(value) {
        this.setState({ select_year: value });
        this.loadData();
    }

    handleMonthChange(value) {
        this.setState({ select_month: value });
        this.loadData();
    }

    loadData() {
        this.setState({ onLoading: true });

        const axios = require('axios');
        const state = JSON.parse(window.localStorage.getItem('state'))
        const userid = state.authen.UserID
        const companyid = window.localStorage.getItem('CompanyID')
        const userInfo = JSON.parse(window.localStorage.getItem('User_Info'))
        const departmentID = userInfo.DepartmentID

        var Token
        axios.get(Constants.BASE_URL + 'auth/token')
            .then((response) => {
                Token = response.data
                axios.get(Odata_2_Url + 'v_SOTMonthlyFollowUp?Year=' + this.state.select_year + "&Month=" + this.state.select_month + "&CompanyID=" + companyid + "&DepartmentID=" + departmentID + "&userId=" + userid,
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then((response) => {
                    console.log(response);
                    var data = []
                    data = response.data

                    this.setState({
                        data: data
                    })

                    this.setState({ onLoading: false });
                }, (error) => {
                    this.setState({ onLoading: false });
                    if (401 === error.response.status) {
                        window.location.href = "auth";
                    }
                    console.log(error)
                })

            })
    }

    render() {
        let min = "2018"
        let max = new Date().getFullYear()
        let year_options = []
        for (var i = min; i <= max; i++) {
            year_options.push(
                <Option value={i} key={i}>{i}</Option>
            )
        }

        let month_options = []
        month_list.map((l, i) => {
            month_options.push(
                <Option value={l.order} key={l.order}>{l.monthName}</Option>
            )
        })

        const columns = [
            {
                title: <IntlMessages id='Name' />,
                dataIndex: this.state.isEng ? 'userFullName_ENG' : 'userFullName_TH'
            },
            {
                title: 'SO Card',
                dataIndex: 'count_SO_Card'
            },
            {
                title: <IntlMessages id='Target' />,
                dataIndex: 'targetpermonth'
            }
        ]

        return (
            <div>
                <Spin spinning={this.state.onLoading} size="large" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }} tip="Loading...">
                    <MenuSider title={<IntlMessages id='menu.so_target' />}>
                        <div style={{ width: "100%", padding: "10px 20px 0 20px" }}>
                            <Collapse defaultActiveKey={['1']}>
                                <Panel header={<IntlMessages id='Filter' />} key="1">
                                    <div style={{ width: "100%", textAlign: "center" }}>
                                        <div>
                                            <Row>
                                                <Select style={{ width: 120, margin: "10px 0px 10px 0px" }} placeholder="Select a month"
                                                    onChange={this.handleMonthChange} defaultValue={this.state.month_now}>
                                                    {month_options}
                                                </Select>
                                                &nbsp; &nbsp;
                                                <Select style={{ width: 120, margin: "10px 0px 10px 0px" }} placeholder="Select a year"
                                                    onChange={this.handleYearChange} defaultValue={max}>
                                                    {year_options}
                                                </Select>
                                                &nbsp; &nbsp;
                                                <Button onClick={this.loadData} style={{ width: 120, margin: "10px 0px 10px 0px" }}><IntlMessages id='Search' /></Button>
                                            </Row>
                                        </div>
                                    </div>
                                </Panel>
                            </Collapse>
                            <Table columns={columns} dataSource={this.state.data}></Table>
                        </div>
                    </MenuSider>
                </Spin>
            </div>
        )
    }
}

//                                                <span>No data available</span>
